import React from "react";
import SiteLayout from "../src/components/layouts/SiteLayout";
import AddressCard from "../src/components/AddressCard";
import PageHeading from "@Components/PageHeading";
import Footer from "../src/components/layouts/Footer";

import { Typography, Divider } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(theme => ({
  divider: {
    marginBottom: theme.spacing(2),
  },
}));

const AboutPage = () => {
  const classes = useStyles();
  return (
    <SiteLayout>
      <PageHeading text="Why Trace?"></PageHeading>
      <Typography paragraph>
        As all insurance claim professionals know, insurance fraud is no
        accident and costs the insurance industry billions of dollars every
        year. For decades Trace America has provided insurance claims
        professionals, risk managers, and defense attorneys with cost effective
        reports that assist in settling the claim or defeat it entirely.
      </Typography>
      <Typography paragraph>
        Our services are inexpensive enough to use routinely, so you can take
        control of your questionable bodily injury claims without spending the
        policy limits. If your claim involves subrogation efforts, we can help
        with that too.
      </Typography>
      <Typography paragraph>
        We are dedicated to providing your company with information that is
        crucial to improving the bottom line. Sound intelligence is smart
        business.
      </Typography>
      <Divider className={classes.divider} light />
      <Typography paragraph>
        Contact us today to inquire about our services that will help improve
        your bottom line.
      </Typography>
      <AddressCard />
      <Footer />
    </SiteLayout>
  );
};

export default AboutPage;
